import { motion } from 'framer-motion';

interface ScheduleSectionProps {
  onRegisterClick: () => void;
}

export default function ScheduleSection({ onRegisterClick }: ScheduleSectionProps) {
  const scheduleItems = [
    {
      icon: 'ri-cup-line',
      title: 'Регистрация+кофе-брейк и заключительный ужин',
      description: 'Приветственный кофе, знакомство с участниками, прощальный ужин',
      image: 'img/1.jpg'
    },
    {
      icon: 'ri-chat-3-line',
      title: 'Открытые дискуссии (2) + мини-лекции-разборы',
      description: 'Обсуждение реальных клинических случаев',
      image: 'img/2.jpg'
    },
    {
      icon: 'ri-movie-2-line',
      title: 'Мини-спектакли «Монплезир» (2)',
      description: 'Культурная программа от лауреатов фестивалей',
      image: 'img/3.jpg'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Интеллектуальная игра (призы)',
      description: 'Интерактивная викторина на смартфонах',
      image: 'img/4.jpg'
    }
  ];

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-[#101A2E] mb-6 text-center" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Как пройдёт вечер
          </h2>
          
          <p className="text-lg text-[#1E2430] text-center mb-12 max-w-3xl mx-auto text-justify">
            Камерная очная встреча «для своих»: регистрация и кофе-брейк, две открытые дискуссии с мини-разборами, между ними — мини-спектакли театра «Монплезир». В финале — интеллектуальная игра на смартфонах и неспешное общение в тёплой обстановке.
          </p>

          <div className="grid md:grid-cols-2 gap-6 mb-12 max-w-4xl mx-auto">
            {scheduleItems.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-2xl overflow-hidden border border-[#D8B36A]/20 hover:border-[#D8B36A]/40 transition-all duration-300 hover:shadow-xl group"
              >
                <div className="relative w-full h-48 overflow-hidden">
                  <img 
                    src={item.image} 
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 w-12 h-12 flex items-center justify-center bg-white/90 backdrop-blur-sm rounded-xl shadow-lg">
                    <i className={`${item.icon} text-[#D8B36A] text-2xl`}></i>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-[#101A2E] mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
                    {item.title}
                  </h3>
                  <p className="text-sm text-[#1E2430]/70">
                    {item.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>

          <div className="text-center">
            <a
              href="https://painmed.ru/event/vtoraya-shkola-komorbidnoj-patologii-peterburzhskie-vechera/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-8 py-4 bg-[#D8B36A] text-[#101A2E] rounded-lg font-bold text-base hover:bg-[#C9A459] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Программа мероприятия
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}